import instance from "../../api/Api";

/**
 *
 * @returns arrya of users watch lists
 */
export const getWatchlists = () => {
  return instance.get("v1/currencies/user-watchlist-api/");
};

/**
 *
 * @param {number} id id of watchlist which want to see details
 * @returns watchlist details
 */
export const getWatchlist = (id) => {
  return instance.get(`v1/currencies/user-watchlist-api/${id}/`);
};

/**
 *
 * @param {number} id id of watchlist which want to delete
 * @returns watch list deleted
 */
export const deleteWatchlist = (id) => {
  return instance.delete(`v1/currencies/user-watchlist-api/${id}/`);
};
/**
 *
 * @param {string} title title of watchlist whcih want to delete them coin
 * @param {string} coinKey key of coint which want to delete from watchlist
 * @returns coint removed from selected watchlist
 */
export const deleteWatchlistCoin = (title, coinKey) => {
  return instance.delete(
    `v1/currencies/user-watchlist-api/${title}/?asset=${coinKey}`
  );
};

/**
 *
 * @param {object} data name and assets
 * @returns watchlist created
 */
export const createWatchlist = (data) => {
  return instance.post(`v1/currencies/user-watchlist-api/`, data);
};

/**
 * Toggles the watchlist asset for a given ID.
 *
 * @param {number} id - The ID of the watchlist.
 * @param {object} data - The data to be sent in the request.
 *
 */
export const toggleWatchlistAsset = (id, data) => {
  return instance.post(`v1/currencies/watchlist/${id}/asset-toggle`, data);
};
